<template>
    <div class="additional-content">
        <div class="additional-content__dropzone">
            <Dropzone
                @remove="handleChange( {...value, file: null})"
                :uploaded-file="typeof value.file === 'string' ? value.file : null"
                :name="dropzoneName"
                @change="handleChange( {...value, file: $event[0] || null})"
                :error="getFirstError('file')"
            ></Dropzone>
        </div>
        <div class="additional-content__form">
            <FormInput
                :value="value.title"
                @input="handleChange( { ...value, title: $event })"
                label="Title"
                name="title"
                class="h:margin-bottom-4"
                :error="getFirstError('title')"
                :required="true"
            >
                {{ trans('global.title') }}
            </FormInput>
            <FormTextArea
                :value="value.description"
                @input="handleChange( { ...value, description: $event })"
                name="description"
                :error="getFirstError('description')"
            >
                {{ trans('global.description') }}
            </FormTextArea>

            <div class="h:margin-top-4">

                <Checkbox :checked="!!value.terms_accepted_at"
                          @change="(checked) => handleChange( { ...value, terms_accepted_at: checked ? 'on' : ''})"
                          :error="getFirstError('terms_accepted_at')"
                >
                    <span v-html="trans('additional-course-contents.terms')"></span>
                    <span class="invalid-feedback" v-if="getFirstError('terms_accepted_at')">
                        <strong>{{ getFirstError('terms_accepted_at') }}</strong>
                    </span>
                </Checkbox>

            </div>
            <div class="additional-content__btn-wrapper">

                <div class="additional-content__sort-buttons">
                    <button
                        class=""
                        @click="$emit('sort', value.order - 1)"
                        v-if="exists && numberOfSiblings > 1"
                        :disabled="value.order === 1"
                        :title="trans('global.move_up')"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                             stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                  d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"/>
                        </svg>
                    </button>
                    <button
                        class=""
                        @click="$emit('sort', value.order + 1)"
                        v-if="exists && numberOfSiblings > 1"
                        :disabled="value.order === numberOfSiblings"
                        :title="trans('global.move_down')"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                             stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                  d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"/>
                        </svg>
                    </button>
                </div>
                <button class="btn btn--big btn--primary" :disabled="!dirty" @click="handleSubmitPress">
                    <span v-if="exists">
                        {{ trans('buttons.refresh') }}
                    </span>
                    <span v-else>
                        {{ trans('buttons.submit') }}
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>

import Checkbox from "../global/Checkbox.vue";

export default {
    components: {Checkbox},
    data() {
        return {
            dropzoneName: `file-${Math.random().toString(36).substring(2, 9)}`,
            initialValueProps: {...this.value},
            submitPressed: false,
        }
    },
    props: {
        course: {
            type: Object,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        },
        errors: {
            type: Array,
        },
        numberOfSiblings: {
            type: Number,
            required: true,
        },
    },
    updated() {
        if (this.submitPressed) {
            this.submitPressed = false
            this.initialValueProps = {...this.value}
        }
    },
    methods: {
        handleChange(value) {

            const oldCheckboxValue = this.value.terms_accepted_at
            const newCheckboxValue = value.terms_accepted_at
            const checkboxChanged = oldCheckboxValue !== newCheckboxValue

            // If we change something else than the checkbox, we need to reset the checkbox
            if(!checkboxChanged) {
                value.terms_accepted_at = '';
            }

            this.$emit('input', value)
        },
        handleSubmitPress() {
            this.submitPressed = true
            this.$emit('submit', this.value)
        },
        getFirstError(key) {
            return this.relevantErrors ? this.relevantErrors[key]?.[0] : ''
        },
        // we need to extract the significant props to check if the form was changed
        // i.e. "order" might change from the outside but should not cause a "dirty" state and enab
        getSignificantDirtyProps(obj) {
            return {
                title: obj.title,
                description: obj.description,
                terms_accepted_at: obj.terms_accepted_at,
                file: obj.file,
            }
        }
    },
    computed: {
        relevantErrors() {
            if (!this.value.id) {
                return this.errors.find(e => !e.id)?.errors
            }

            return this.errors.find(e => e.id === this.value.id)?.errors
        },
        dirty() {
            return JSON.stringify(this.getSignificantDirtyProps(this.value))
                !==
                JSON.stringify(this.getSignificantDirtyProps(this.initialValueProps))
        },
        exists() {
            return !!this.value.id
        }
    },
}
</script>
